import pdfMake from 'pdfmake/build/pdfmake'
import { useState } from 'react'
import { Col, Container, Form, Row, Table } from 'react-bootstrap'
import { DatabaseFillGear, FileEarmarkPdfFill } from 'react-bootstrap-icons'
import { CustomButton } from '../../../../components/CustomButton'
import { useOrdenation } from '../../../../hooks/useOrdenation'
import WmsRelatorioService from '../../../../services/database/WmsRelatorioService'
import { formatDate } from '../../../../utils/formatDate'
import { sendErrorApiMessage } from '../../../../utils/sendErrorApiMessage'

pdfMake.fonts = {
  Roboto: {
    normal:
      'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.7/fonts/Roboto/Roboto-Regular.ttf',
    bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.7/fonts/Roboto/Roboto-Medium.ttf',
    italics:
      'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.7/fonts/Roboto/Roboto-Italic.ttf',
    bolditalics:
      'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.7/fonts/Roboto/Roboto-MediumItalic.ttf',
  },
}

export function HistoricoMovimentacao() {
  const [sku, setSku] = useState('')
  const [data, setData] = useState([])
  const [isRequestLoading, setIsRequestLoading] = useState(false)

  const { filteredItems, Th, Paginate, itemsPerPage, setItemsPerPage } =
    useOrdenation(data, 'rua', 'desc', '25')

  async function handleGetData() {
    try {
      setIsRequestLoading(true)

      const response = await WmsRelatorioService.historicoMovimentacao(sku)

      setData(response)
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao buscar informações')
    } finally {
      setIsRequestLoading(false)
    }
  }

  function handleGeneratePDF(dados) {
    const docDefinition = {
      pageSize: 'A4',
      pageOrientation: 'landscape', // Importante: modo paisagem
      pageMargins: [40, 60, 40, 60],
      content: [
        {
          text: 'Relatório de Histórico de Movimentação',
          style: 'header',
          alignment: 'center',
          margin: [0, 0, 0, 5],
        },
        {
          text: `Gerado em ${new Date().toLocaleDateString('pt-BR')} às ${new Date().toLocaleTimeString('pt-BR')}`,
          style: 'subheader',
          alignment: 'center',
          margin: [0, 0, 0, 30],
        },
        {
          table: {
            headerRows: 1,
            widths: ['*', '*', '*', '*', '*', '*', '*', '*'], // Porcentagens fixas
            body: [
              [
                { text: 'SKU', style: 'tableHeader' },
                { text: 'SKU Coleta', style: 'tableHeader' },
                { text: 'End. Origem', style: 'tableHeader' },
                { text: 'End.', style: 'tableHeader' },
                { text: 'Tipo OS.', style: 'tableHeader' },
                { text: 'Qtde.', style: 'tableHeader' },
                { text: 'Data', style: 'tableHeader' },
                { text: 'Núm. Pedido', style: 'tableHeader' },
              ],
              ...dados.map((item) => [
                { text: item.codprod, style: 'tableCell' },
                {
                  text: item.skucoleta,
                  style: 'tableCell',
                  alignment: 'center',
                },
                {
                  text: item.codenderecoorig,
                  style: 'tableCell',
                  alignment: 'center',
                },
                {
                  text: item.codendereco,
                  style: 'tableCell',
                  alignment: 'center',
                },
                { text: item.tipoos, style: 'tableCell', alignment: 'center' },
                { text: item.qt, style: 'tableCell', alignment: 'center' },
                {
                  text: formatDate(item.data),
                  style: 'tableCell',
                  alignment: 'center',
                },
                { text: item.numped, style: 'tableCell', alignment: 'center' },
              ]),
            ],
          },
          layout: {
            fillColor: function (rowIndex) {
              return rowIndex === 0
                ? '#667eea'
                : rowIndex % 2 === 0
                  ? '#f8f9fa'
                  : null
            },
            hLineWidth: function (i, node) {
              return i === 0 || i === 1 || i === node.table.body.length
                ? 1
                : 0.5
            },
            vLineWidth: function () {
              return 0
            },
            hLineColor: function (i) {
              return i === 0 || i === 1 ? '#667eea' : '#e0e0e0'
            },
          },
        },
        {
          text: `Total de registros: ${dados.length}`,
          style: 'footer',
          margin: [0, 20, 0, 0],
        },
      ],

      styles: {
        header: {
          fontSize: 22,
          bold: true,
          color: '#333',
        },
        subheader: {
          fontSize: 11,
          color: '#666',
        },
        tableHeader: {
          fontSize: 10,
          bold: true,
          color: '#ffffff',
          fillColor: '#667eea',
        },
        tableCell: {
          fontSize: 9,
          color: '#333',
        },
        footer: {
          fontSize: 10,
          italics: true,
          color: '#666',
          alignment: 'right',
        },
      },
    }

    pdfMake.createPdf(docDefinition).open()
  }

  return (
    <Container>
      <h1>Histórico de Movimentação</h1>

      <Row className="mb-3">
        <Col xs={2}>
          <Form.Label>Items p. pág</Form.Label>
          <Form.Select
            value={itemsPerPage}
            onChange={(e) => setItemsPerPage(e.target.value)}
          >
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </Form.Select>
        </Col>
      </Row>

      <Row>
        <div
          style={{
            width: '100%',
            display: 'flex',
            alignItems: 'flex-end',
            gap: 5,
          }}
        >
          <Form.Group>
            <Form.Label>SKU</Form.Label>

            <Form.Control
              value={sku}
              onChange={(e) => setSku(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' && sku) {
                  handleGetData()
                }
              }}
            />
          </Form.Group>

          <CustomButton
            noMargin
            title="Gerar Dados"
            onClick={handleGetData}
            isLoading={isRequestLoading}
            isLoadingText="Gerando..."
            isDisabled={!sku}
          >
            <DatabaseFillGear size={22} />
          </CustomButton>

          <CustomButton
            noMargin
            title="Gerar PDF"
            onClick={() => handleGeneratePDF(data)}
            isDisabled={data.length === 0}
          >
            <FileEarmarkPdfFill size={22} />
          </CustomButton>
        </div>
      </Row>

      {data.length > 0 && (
        <>
          <Table>
            <thead>
              <tr>
                <th colSpan="4">
                  <p>
                    Mostrando {filteredItems.length} de {data.length}
                  </p>
                </th>
              </tr>
              <tr>
                <Th
                  label="SKU"
                  value="codprod"
                />
                <Th
                  label="SKU Coleta"
                  value="skucoleta"
                />
                <Th
                  label="End. Origem"
                  value="codenderecoorig"
                />
                <Th
                  label="End."
                  value="codendereco"
                />
                <Th
                  label="Tipo OS"
                  value="tipoos"
                />
                <Th
                  label="Qtde"
                  value="qt"
                />
                <Th
                  label="Data"
                  value="data"
                />
                <Th
                  label="Núm. Pedido"
                  value="numped"
                />
              </tr>
            </thead>

            <tbody>
              {filteredItems.map((item) => (
                <tr>
                  <td>{item.codprod}</td>
                  <td>{item.skucoleta}</td>
                  <td>{item.codenderecoorig}</td>
                  <td>{item.codendereco}</td>
                  <td>{item.tipoos}</td>
                  <td>{item.qt}</td>
                  <td>{formatDate(item.data)}</td>
                  <td>{item.numped}</td>
                </tr>
              ))}
            </tbody>
          </Table>

          <Paginate />
        </>
      )}
    </Container>
  )
}
